import { api } from '../config/api'

const baseEndpoint = '/AcademicCourseApi'

export const getAcademicCourses = (schoolId) => api.get(baseEndpoint, { params: { schoolId } })

export const getAdminAcademicCourses = (schoolId) => api.get(`${baseEndpoint}/School/${schoolId}`)
